import React from 'react';
import { Wrapper } from './styles';
export const Cross = ({ height, width, onClick }) => {
    return (React.createElement(Wrapper, { height: height, width: width, onClick: onClick },
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M1.5 1.61111L22.5 22.3889", stroke: "black", strokeLinecap: "square" }),
            React.createElement("path", { d: "M22.5 1.61111L1.5 22.3889", stroke: "black", strokeLinecap: "square" }))));
};
